import { connect } from 'react-redux'

import MessageCardOptions from '../../components/messages/message-card-options'

import { deleteUnreadMessage } from '../../actions/messages'

function mapDispatchToProps (dispatch, ownProps) {
  return {
    deleteUnreadMessage () {
      dispatch(deleteUnreadMessage(ownProps.messageId))
    }
  }
}

export default connect(undefined, mapDispatchToProps)(MessageCardOptions)



// WEBPACK FOOTER //
// ./src/containers/messages/message-card-options-container.js